/*!
 * Offsure Carousel — progressive enhancement over native scroll-snap.
 * No dependencies. Pointer-drag on desktop, native touch swipe, keyboard
 * arrows, prev/next buttons, progress bar or dots, aria-live status.
 * Honors prefers-reduced-motion (disables autoplay + smooth scroll behavior).
 * Markup and CSS keep the carousel fully usable with this script absent.
 */
(function () {
  if (window.__offsureCarouselReady) return;
  window.__offsureCarouselReady = true;

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (root.__oscInit) return;
    root.__oscInit = true;

    var viewport = root.querySelector('.osc__viewport');
    if (!viewport) return;
    var slides = Array.prototype.slice.call(viewport.children);
    if (!slides.length) return;

    var prevBtn = root.querySelector('[data-osc-prev]');
    var nextBtn = root.querySelector('[data-osc-next]');
    var status = root.querySelector('.osc__status');
    var progressBar = root.querySelector('.osc__progress-bar');
    var dots = Array.prototype.slice.call(root.querySelectorAll('.osc__dot'));
    var autoplayMs = parseInt(root.getAttribute('data-osc-autoplay') || '0', 10);
    var loop = root.getAttribute('data-osc-loop') === 'true';
    var autoplayTimer = null;
    var current = 0;

    function slideIndexAt(scrollLeft) {
      var best = 0, bestDist = Infinity;
      slides.forEach(function (s, i) {
        var d = Math.abs(s.offsetLeft - scrollLeft);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      return best;
    }

    function update() {
      current = slideIndexAt(viewport.scrollLeft);
      var max = viewport.scrollWidth - viewport.clientWidth - 1;
      if (prevBtn) prevBtn.disabled = viewport.scrollLeft <= 0 && !loop;
      if (nextBtn) nextBtn.disabled = viewport.scrollLeft >= max && !loop;
      if (status) status.textContent = (current + 1) + ' of ' + slides.length;
      if (progressBar) {
        var pct = slides.length > 1 ? (current / (slides.length - 1)) * 100 : 0;
        progressBar.style.width = pct + '%';
      }
      dots.forEach(function (d, i) {
        d.setAttribute('aria-current', i === current ? 'true' : 'false');
      });
    }

    function goTo(index) {
      if (loop) index = (index + slides.length) % slides.length;
      index = Math.max(0, Math.min(slides.length - 1, index));
      var target = slides[index];
      viewport.scrollTo({
        left: target.offsetLeft,
        behavior: REDUCE ? 'auto' : 'smooth'
      });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { goTo(i); });
    });

    // Debounced scroll -> update UI state
    var scrollRaf = null;
    viewport.addEventListener('scroll', function () {
      if (scrollRaf) return;
      scrollRaf = requestAnimationFrame(function () {
        update();
        scrollRaf = null;
      });
    }, { passive: true });

    // Keyboard arrows when the carousel or a child has focus
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
    });

    // Pointer drag on desktop (fine pointer + hover), native touch untouched
    var canDrag = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (canDrag) {
      var dragging = false, startX = 0, startScroll = 0, moved = false;
      viewport.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;
        dragging = true;
        moved = false;
        startX = e.clientX;
        startScroll = viewport.scrollLeft;
        root.setAttribute('data-osc-dragging', 'true');
        viewport.setPointerCapture(e.pointerId);
      });
      viewport.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 4) moved = true;
        viewport.scrollLeft = startScroll - dx;
      });
      function endDrag(e) {
        if (!dragging) return;
        dragging = false;
        root.removeAttribute('data-osc-dragging');
        goTo(slideIndexAt(viewport.scrollLeft));
      }
      viewport.addEventListener('pointerup', endDrag);
      viewport.addEventListener('pointercancel', endDrag);
      viewport.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
      }, true);
    }

    // Autoplay: off by default; opt-in via data-osc-autoplay, paused on hover/focus, disabled under reduced motion
    function stopAutoplay() {
      if (autoplayTimer) { clearInterval(autoplayTimer); autoplayTimer = null; }
    }
    function startAutoplay() {
      if (!autoplayMs || REDUCE) return;
      stopAutoplay();
      autoplayTimer = setInterval(function () {
        var atEnd = current >= slides.length - 1;
        goTo(atEnd ? (loop ? current + 1 : 0) : current + 1);
      }, autoplayMs);
    }
    if (autoplayMs && !REDUCE) {
      startAutoplay();
      root.addEventListener('mouseenter', stopAutoplay);
      root.addEventListener('mouseleave', startAutoplay);
      root.addEventListener('focusin', stopAutoplay);
      root.addEventListener('focusout', startAutoplay);
    }

    update();
    window.addEventListener('resize', update);
  }

  function boot() {
    document.querySelectorAll('.osc').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
